import { X, Rocket, BookOpen } from 'lucide-react';
import { useOnboardingStore } from '../../store/onboardingStore';
import { Button } from '../ui';

export function WelcomePrompt() {
  const {
    hasSeenWelcomePrompt,
    welcomePromptDismissed,
    markWelcomePromptSeen,
    dismissWelcomePrompt,
    startTour,
  } = useOnboardingStore();

  // Don't show if already seen or dismissed permanently
  if (hasSeenWelcomePrompt || welcomePromptDismissed) {
    return null;
  }

  const handleTakeTour = () => {
    markWelcomePromptSeen();
    startTour('welcome');
  };

  const handleMaybeLater = () => {
    markWelcomePromptSeen();
  };

  const handleDontAskAgain = () => {
    dismissWelcomePrompt();
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-white dark:bg-dark-elevated rounded-xl shadow-2xl max-w-md w-full mx-4 overflow-hidden">
        {/* Header with gradient */}
        <div className="bg-gradient-to-r from-purple-600 to-purple-700 px-6 py-8 text-white text-center">
          <div className="w-16 h-16 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-4">
            <Rocket className="w-8 h-8" />
          </div>
          <h2 className="text-2xl font-bold mb-2">Welcome to Auto-Translator!</h2>
          <p className="text-purple-100 text-sm">
            Your AI-powered document translation platform
          </p>
        </div>

        {/* Content */}
        <div className="px-6 py-6">
          <p className="text-gray-600 dark:text-gray-300 text-center mb-6">
            Would you like a quick tour to learn how to use the platform?
            You can always access tutorials later from the help button.
          </p>

          {/* Actions */}
          <div className="space-y-3">
            <Button
              variant="primary"
              size="md"
              className="w-full justify-center"
              onClick={handleTakeTour}
            >
              <BookOpen className="w-4 h-4 mr-2" />
              Take the Tour
            </Button>

            <Button
              variant="secondary"
              size="md"
              className="w-full justify-center"
              onClick={handleMaybeLater}
            >
              Maybe Later
            </Button>

            <button
              onClick={handleDontAskAgain}
              className="w-full text-center text-sm text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 py-2 transition-colors"
            >
              Don't ask again
            </button>
          </div>
        </div>

        {/* Close button */}
        <button
          onClick={handleMaybeLater}
          className="absolute top-4 right-4 text-white/70 hover:text-white transition-colors"
          aria-label="Close"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
}
